import "../chunk-PKUHTIDK.js";
import {
  computedNavStyle,
  computedSizeName,
  updated,
  visibilityChangeHandler,
  windowBlurHandler,
  windowFocusHandler,
  scrollToActiveTab,
  scrollIntoView,
  mounted,
  moreTabShow,
  expandTabShow,
  expandTabHide,
  computedHeaderStyle,
  beforeUnmount,
  scrollPrev,
  scrollNext,
  changeTab,
  setFocus,
  removeFocus,
  sortableEvent,
  handleTabDragStart,
  handleTabDragEnd,
  watchCurrentName
} from "./index";
const api = [
  "state",
  "setFocus",
  "removeFocus",
  "scrollPrev",
  "scrollNext",
  "changeTab",
  "scrollToActiveTab",
  "scrollIntoView",
  "moreTabShow",
  "expandTabShow",
  "expandTabHide",
  "computedHeaderStyle",
  "swiperHandle"
];
const renderless = (props, { computed, inject, onBeforeUnmount, onMounted, onUpdated, reactive, markRaw }, { parent, nextTick, refs, mode: tinyMode, emit }) => {
  const api2 = { mounted, beforeUnmount, computedNavStyle, computedSizeName };
  const state = reactive({
    dragging: false,
    navOffset: 0,
    lineOffset: 0,
    scrollable: false,
    isFocus: false,
    focusable: false,
    showMoreItem: false,
    isActive: false,
    showMoreTabs: props.showMoreTabs,
    showExpandItem: false,
    showExpandTabs: props.showExpandTabs,
    expandHeaderStyle: {},
    mode: props._mode || parent.$mode || tinyMode || "pc",
    rootTabs: inject("rootTabs"),
    sizeName: computed(() => api2.computedSizeName(state)),
    navStyle: computed(() => api2.computedNavStyle(state))
  });
  Object.assign(api2, {
    state,
    setFocus: setFocus(state),
    removeFocus: removeFocus(state),
    moreTabShow: moreTabShow(state),
    expandTabShow: expandTabShow({ api: api2, state }),
    expandTabHide: expandTabHide(state),
    scrollPrev: scrollPrev({ refs, state }),
    scrollNext: scrollNext({ refs, state }),
    windowBlurHandler: windowBlurHandler(state),
    windowFocusHandler: windowFocusHandler(state),
    visibilityChangeHandler: visibilityChangeHandler(state),
    scrollToActiveTab: scrollToActiveTab({ parent, refs, state }),
    scrollIntoView: scrollIntoView({ parent, refs, state }),
    computedHeaderStyle: computedHeaderStyle({ refs, state }),
    watchCurrentName: watchCurrentName({ nextTick, refs, state }),
    handleTabDragStart: handleTabDragStart({ state, refs, emit }),
    handleTabDragEnd: handleTabDragEnd({ state, refs, nextTick }),
    sortableEvent: sortableEvent({ api: api2, props, state, refs, emit, markRaw })
  });
  Object.assign(api2, { updated: updated({ api: api2, refs, state }), changeTab: changeTab(api2) });
  onUpdated(() => api2.updated());
  onMounted(() => api2.mounted({ api: api2, parent }));
  onBeforeUnmount(() => api2.beforeUnmount({ api: api2, parent }));
  return api2;
};
export {
  api,
  renderless
};
